<template lang="pug">
div.ag-custom-cell
  v-money(
    ref='detailsMoneys'
    :currency='params.data && params.data.CurrencyCode'
    v-if='params.colDef.cellClass === "amount"') {{ params.value }}
  div.ag-detail-cell-value(v-else)
    component(v-if='params.colDef.detailsRender' :is='params.colDef.detailsRender' :params='params')
    span(v-else) {{params.value}}
  | &nbsp;&nbsp;
  i(:class='`fal fa-${shownDetails ? "minus" : "plus"}-circle ag-row-expand-icon`'
    v-if='params.colDef.hasDetails && detailsCondition'
    @click='showDetails'
  )
  div.ag-row-details(v-if='shownDetails' :style='position', :class='{ "shown": shownDetails }' v-on-clickaway='hideDetails')
    i.ag-row-expand-close.fal.fa-times(:style='closeIconPosition' @click='showDetails')
    div.ag-row-details-content.col-md-12(:style='contentPosition')
      div.ag-row-expanded-body(ref='body')
        component(v-if='shownDetails && loadedDetails' :is='params.comps' :model='detailsModel' :currency='this.params.context.currencyCode')
          .details(slot='body')
            div(v-html='htmlDetails')
</template>

<script>

import { mixin as clickaway } from 'vue-clickaway'

const DEFAULT_ROW_HEIGHT = 35
const DEFAULT_HEIGHT = 120

export default {
  mixins: [ clickaway ],

  data() {
    return {
      htmlDetails: '',
      shownDetails: false,
      loadedDetails: false,
      details: [Object, String],
      contentBodyHeight: DEFAULT_HEIGHT
    }
  },

  computed: {
    /* shownDetails() {
      return this.params.data._expanded || this._shownDetails
    }, */

    position() {
      return {
        left: `-${this.cell.offsetLeft + this.colApi.leftWidth}px`,
        width: (this.params.column.pinned
                ? this.colApi.leftWidth
                : this.colApi.bodyWidth + this.colApi.rightWidth + this.colApi.leftWidth
              ) + 'px',
        height: `${this.contentBodyHeight - DEFAULT_ROW_HEIGHT}px`
      }
    },

    contentPosition() {
      return {
        marginLeft: this.params.column.pinned ? 0 : this.colApi.scrollPosition + 'px'
      }
    },

    closeIconPosition() {
      return {
        display: this.params.column.colId === 'details' ? 'none' : 'block',
        marginLeft: !this.params.column.pinned
                    ? this.colApi.scrollPosition +
                      this.colApi.rightWidth +
                      this.colApi.scrollWidth - 30 +
                      'px'
                    : this.colApi.rightWidth +
                      this.colApi.leftWidth - 20 +
                      'px'
      }
    },

    detailsModel() {
      return this.details
    },

    detailsCondition() {
      return this.params && this.params.data && this.params.detailsCondition && this.params.detailsCondition(this.params)
    }
  },

  created() {
    let detailsLocation = this.getDetailsLocation()

    this.colApi = this.params.api.columnController

    this.cell = this.params.eGridCell
    this.cell.style.overflow = 'visible'

    if (detailsLocation === 'local') {
      this.getDetails()
    }
    this.shownDetails = this.params.data && this.params.data._expanded
  },

  mounted() {
    this.shownDetails && this.doExpand(true)
  },

  methods: {
    showDetails() {
      this.shownDetails = !this.shownDetails
      // this.params.context.shownDetails = this.shownDetails

      !this.loadedDetails && this.getDetails()

      if (this.getDetailsLocation() === 'local') {
        this.doExpand()
      }
    },

    getDetailsLocation() {
      return this.params.colDef.hasDetails
    },

    hideDetails() {
      if (!this.params.context.data) {
        this.shownDetails = !this.shownDetails
      }
    },

    getDetails() {
      let detailsLocation = this.getDetailsLocation()

      // local
      if (detailsLocation === 'local') {
        this.details = this.params.data
        this.loadedDetails = true
      } else {
        // remote
        let apiPath = detailsLocation.split('.')
        let path = this.api.$[apiPath[0]][apiPath[1]]

        this.api.forms.post(`${path}${this.params.colDef.detailsParamsURL && this.params.colDef.detailsParamsURL(this.params)}`, {
          // id: this.params.data[this.params.colDef.uid],
          gridID: this.params.context.alias
        }).then(r => {
          this.details = r.data
          this.loadedDetails = true
          this.doExpand()
        })
      }
    },
    computeHeight() {
      this.contentBodyHeight = this.$refs.body ? this.$refs.body.clientHeight + DEFAULT_ROW_HEIGHT + 40 : this.contentBodyHeight

      //
      // this.cell.parentNode.setAttribute('data-computed-height', this.contentBodyHeight)
    },
    doExpand(reset) {
      this.cell.parentNode.className = this.cell.parentNode.className.replace(' ag-row-expanded', '') + (this.shownDetails ? ' ag-row-expanded' : '')
      this.cell.className = this.cell.className.replace(' ag-cell-expanded', '') + (this.shownDetails ? ' ag-cell-expanded' : '')

      this.$nextTick(() => {
        this.computeHeight()
        typeof this.shownDetails !== 'undefined' && this.params.context.$emit('expandedRow', {
          expanded: this.shownDetails,
          index: this.params.rowIndex,
          height: this.contentBodyHeight - DEFAULT_ROW_HEIGHT,
          reset
        })
      })
    }
  }
}

</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.ag-custom-cell {
  display: inline-block;
  min-width: 75%;
}

.ag-detail-cell-value {
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 85%;
}

.ag-row-expand-icon {
  font-size: $font-size-base;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(ink);
  }
}
.ag-row-expand-close {
  font-size: $font-size-base-lg;
  vertical-align: middle;
  cursor: pointer;
  @include theme {
  color: v(ink);
  }
  position: absolute;
  left: -10px;
  z-index: 2;
}

.ag-row-details.shown {
  background: #fff;
  @include theme {
  border-top: 1px solid v(background);
  border-bottom: 1px solid v(background);
  }
  position: absolute;
  top: 35px;
  left: auto;
  width: auto;
  height: 120px;
  margin: -1px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: -1;
  padding: 10px 20px 15px 30px;
  
  .ag-row-details-content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    label {
      font-size: $font-size-base-sm;
      font-weight: $font-weight-ultra-bold;
    }
  }

  &.shown {
    opacity: 1;
    z-index: 1;
    cursor: text;
    user-select: text;
  }
}

.ag-row-expanded {
  /*@include theme {
  background: lighten(v(secondary-04), 8%);
  }*/
}
//.theme .ag-cell-expanded,
.ag-cell-focus.ag-cell-expanded {
  border-color: transparent;
  @include theme {
  border-bottom: 3px solid v(tertiary-01);
  }
}

.details ul li {
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// src/components/Grid/details.vue